var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import styled from "styled-components";
import { Button, propStyling, tombac } from "tombac";
export var Dot = styled.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  all: initial;\n\n  background-color: ", ";\n  border: ", " solid ", ";\n  border-radius: 50%;\n  cursor: inherit;\n  height: ", ";\n  position: absolute;\n  right: ", ";\n  width: ", ";\n  top: ", ";\n\n  @media (max-width: ", ") {\n    border: 0;\n    height: ", ";\n    margin-left: auto;\n    position: static;\n    width: ", ";\n  }\n"], ["\n  all: initial;\n\n  background-color: ", ";\n  border: ", " solid ", ";\n  border-radius: 50%;\n  cursor: inherit;\n  height: ", ";\n  position: absolute;\n  right: ", ";\n  width: ", ";\n  top: ", ";\n\n  @media (max-width: ", ") {\n    border: 0;\n    height: ", ";\n    margin-left: auto;\n    position: static;\n    width: ", ";\n  }\n"])), function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? "danger" : _b;
    return tombac.color(variant, 500);
}, tombac.unit(2), tombac.color.white, tombac.unit(7), tombac.unit(7), tombac.unit(7), tombac.unit(7), function (_a) {
    var _b = _a.breakpoint, breakpoint = _b === void 0 ? 768 : _b;
    return tombac.unit(breakpoint);
}, tombac.unit(10), tombac.unit(10));
export var IconButton = forwardRef(function (_a, ref) {
    var as = _a.as, props = __rest(_a, ["as"]);
    return (React.createElement(StyledIconButton, __assign({ shape: "circle", variant: "flat" }, props, { forwardedAs: as, ref: ref })));
});
var StyledIconButton = styled(Button)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: relative;\n\n  & svg {\n    display: block;\n  }\n\n  ", "\n"], ["\n  position: relative;\n\n  & svg {\n    display: block;\n  }\n\n  ", "\n"])), propStyling);
var templateObject_1, templateObject_2;
//# sourceMappingURL=IconButton.js.map